import React, { useContext } from 'react';
import { useFormikContext } from 'formik';
import { isEmpty } from 'lodash';
import { ArnContext, FormContext } from 'contexts';
import FileUpload from './FileUpload';
import { ArnApplicationDvsMethodFormData } from 'types/forms/arnApplicationTypes';
import {
  ApplicationName,
  FormNavigation
} from 'components/CASAForm';
import { AuDirectionLink } from 'components/DTA';
import { IFormAlertType } from 'types/forms/formTypes';
import { getNameChangeDocumentTitleAndDataModel } from 'helpers/arnApplicationHelper';

const UploadFileForNameChange: React.FC = () => {
  const { handleBack } = useContext(FormContext);
  const { setPreviousStep, previousStep } = useContext(ArnContext);
  const { values, setFieldValue, validateForm, getFieldMeta } = useFormikContext<ArnApplicationDvsMethodFormData>();
  const { setFormAlert, openStepById, setOnChangeValidation } = useContext(FormContext);
  const identity = getNameChangeDocumentTitleAndDataModel(values?.previousName?.changeOfNameDocument);

  const handleBackAction = () => {
    setFieldValue(`${identity.identityType}.isManualUpload`, false);

    if (previousStep && previousStep === 'UploadFileForManualNameChangeIdentification') {
      setPreviousStep('NameChangeDetails');
      openStepById('NameChangeDetails');
      return;
    }

    if (previousStep) {
      openStepById(previousStep);
      return;
    }

    handleBack();
  };

  const handleNext = async () => {
    const validationErrors = await validateForm();
    // Proceed to DeclarationAndSubmit if there aren't any errors
    if (!validationErrors || isEmpty(validationErrors)) {
      setFormAlert(null);
      setOnChangeValidation(false);
      const nextStepsId = 'DeclarationAndSubmit';
      const previousStepId = 'UploadFileForManualNameChangeIdentification';
      setPreviousStep(previousStepId);
      openStepById(nextStepsId);
      setOnChangeValidation(false);
      return;
    }

    const alert: IFormAlertType = {
      as: 'error',
      title: 'There was a problem with the form',
      message: 'Please check the form below and try again'
    };

    setFormAlert(alert);
    setOnChangeValidation(true);
  };

  const isManualUpload = getFieldMeta(`${identity.identityType}.isManualUpload`).value;
  if (isManualUpload === false) {
    openStepById('NameChangeDetails');
  }

  return (
    <>
      <ApplicationName name='Upload identification' />
      <AuDirectionLink onClick={handleBackAction} text="Back" direction="left" />
      <FileUpload documentType={identity?.title} identityType={identity?.identityType} />
      <FormNavigation nextButtonText='Next' hidePrevious onNextAction={handleNext} showSaveAndExit={false} />
    </>
  );
};

export default UploadFileForNameChange;